import React from 'react'
import { useTranslation } from 'react-i18next'
import dayjs from 'dayjs'
import { usePickByLanguage } from '@/hooks/use-pick-by-language'
import { CheckinReceiptSheet } from '@/utils/checkin-receipt-sheets'

type Props = {
  stay: CheckinReceiptSheet['stay']
}

export const StaySection: React.FC<Props> = ({ stay }) => {
  const { t } = useTranslation()
  const pickByLanguage = usePickByLanguage()
  return (
    <div className="reservation-block">
      <div className="list-item">
        <span className="label">{t('Your name')}</span>
        <span className="value">
          {stay.guestName} {t('SelfCheckIn.To')}
        </span>
      </div>
      <div className="list-item">
        <span className="label">{t('SelfCheckIn.No. of guests')}</span>
        <span className="value">
          {t('Adult')} : {stay.paxOfAdults}、{t('Child')} : {stay.paxOfChildren}
        </span>
      </div>
      <div className="list-item">
        <span className="label">{t('SelfCheckIn.Period of stay')}</span>
        <span className="value">
          {dayjs(stay.checkinDate).format('MM/DD')} ~ {dayjs(stay.checkoutDate).format('MM/DD')}
        </span>
      </div>
      {stay.plan && (
        <div className="list-item">
          <span className="label">{t('Plan name')}</span>
          <span className="value">{pickByLanguage(stay.plan)}</span>
        </div>
      )}
      {stay.timeSelections.map((timeSelection, timeSelectionIndex) => (
        <div className="list-item" key={timeSelectionIndex}>
          <span className="label">{pickByLanguage(timeSelection.title)}</span>
          <span className="value">
            {timeSelection.from.map((from, fromIndex) => (
              <React.Fragment key={fromIndex}>
                {dayjs(from).format('MM/DD(ddd) HH:mm')}
                <br />
              </React.Fragment>
            ))}
          </span>
        </div>
      ))}
    </div>
  )
}
